// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttons = "InternalSidebar__buttons__eijx4";
export const counterContainer = "InternalSidebar__counterContainer__xaWCm";
export const descended = "InternalSidebar__descended__hGzl3";
export const descendingPane = "InternalSidebar__descendingPane__9niKv";
export const floating = "InternalSidebar__floating__bCTlt";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "InternalSidebar__header__frHjK";
export const internalSidebar = "InternalSidebar__internalSidebar__wVQi0 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const logo = "InternalSidebar__logo__oy6a7";
export const mainPane = "InternalSidebar__mainPane__Df+UW";
export const mainPaneHeight = "var(--main-pane-height)";
export const medium = "500";
export const menuButton = "InternalSidebar__menuButton__-yzaJ";
export const navigation = "InternalSidebar__navigation__cylHX";
export const navigationButton = "InternalSidebar__navigationButton__qtMpF";
export const notificationsTrayButton = "InternalSidebar__notificationsTrayButton__iRbwl";
export const notificationsTrayButtonWrapper = "InternalSidebar__notificationsTrayButtonWrapper__uF8WP";
export const panesWrapper = "InternalSidebar__panesWrapper__etLb9";
export const peergroupsButtonWrapper = "InternalSidebar__peergroupsButtonWrapper__AjIT8";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";